import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppStore } from "@/hooks/useAppStore";

export const ProtectedRoute = () => {
    const user = useAppStore((state) => state.user);
    const location = useLocation();

    const requestedPath = location.pathname;

    if (!user) {
        if (requestedPath == '/translate' || requestedPath == '/new-room') {
            return <Navigate to={`/guest-login?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />;
        }
        return <Navigate to="/login" replace />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
